import { authenticatedFetch } from './utils/request';

export default async function fetchAuthenticatedUser() {
    return await authenticatedFetch('/web-admin-data/whoami');
}
